import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShoppingCart, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/dealer/wishlist"); setItems(data); };
  useEffect(() => { load(); }, []);
  const addCart = async (item) => { try { await api.post("/dealer/cart", { product_id: item.product_id, qty: 1 }); toast.success("Moved to cart"); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };
  const remove = async (item) => { await api.delete(`/dealer/wishlist/${item.product_id}`); load(); };
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-wishlist">
      <div><h1 className="font-display text-2xl sm:text-3xl font-black">Wishlist</h1><p className="text-muted-foreground">Saved products you can move to cart in one click.</p></div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {items.map((w) => (
          <Card key={w.id} data-testid={`wish-${w.product_id}`}>
            <CardContent className="p-4 space-y-2">
              {w.image && <img src={w.image} alt={w.title} className="w-full aspect-square object-cover rounded" />}
              <div className="font-semibold line-clamp-1">{w.title}</div>
              <div className="font-display text-lg font-bold">₹{(w.price || 0).toLocaleString()}</div>
              <div className="flex gap-2"><Button size="sm" onClick={() => addCart(w)} className="flex-1" data-testid={`wish-add-${w.product_id}`}><ShoppingCart className="w-4 h-4 mr-1" /> Cart</Button><Button size="sm" variant="ghost" onClick={() => remove(w)}><Trash2 className="w-4 h-4" /></Button></div>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-muted-foreground py-16">Wishlist is empty.</div>}
      </div>
    </div>
  );
}
